<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<h2 class="text-primary mb-4">{{ $t('Promos') }}</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<button
						class="btn btn-submit btn-default"
						@click="addItem">
						{{ $t('Add Promo') }}
					</button>
				</div>
				<!-- counting -->
				<div class="mr-3 ml-a">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th>{{ $t('No') }}</th>
						<th>{{ $t('Name') }}</th>
						<th>{{ $t('Type') }}</th>
						<!-- <th>{{ $t('Description') }}</th> -->
						<th>{{ $t('Discount') }}</th>
						<th>{{ $t('Duration') }}</th>
						<th>{{ $t('Expired') }}</th>
						<th width="25%">{{ $t('') }}</th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="(item, index) in items"
						:key="item.id">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ numberingList(index) }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.name }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.type }}</td>
						<!-- <td>{{ item.description }}</td> -->
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.length }} {{item.discount}}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.duration }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ dateFormat(item.expired_at) }}</td>
						<td class="btn-action-table" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								@click="showModalPromoCodeList(item)">
								<i class="material-icons md-18" v-tooltip="'Promo Code'">list</i>
							</button>
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								@click="editItem(item)">
								<i class="material-icons md-18">edit</i>
							</button>
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-danger btn-icon"
								@click="confirmRemoveItem(item)">
								<i class="material-icons md-18">delete</i>
							</button>
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon ml-2"
								v-tooltip="'Send Coupon'"
								@click="showModalAddPromo(item)">
								<i class="material-icons md-18">people</i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No Promo available')}}</div>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Promos Form -->
			<promo-form
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible && !isFetchingPackage"
				:packagesParent="packages"
			/>
			<!-- promo code list Features -->
			<modal-promo-code-list
				:dataPromo="selected"
				:isNewPromo="isNewPromo"
				@close="isModalPromoCodeListVisible = false"
				@resetNewPromo="resetNewPromo"
				v-if="isModalPromoCodeListVisible"
			/>
			<!-- promo Assign -->
			<modal-add-promo
				:data="selected"
				@close="isModalAddPromoVisible = false"
				v-if="isModalAddPromoVisible"
			/>
			<!-- Delete Confirmation -->
			<modal
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					<h3>{{ $t('Remove Promo') }}</h3>
				</template>
				<template slot="body">
					{{ $t('Are you sure want to delete') }} {{ showModalName(selected && selected.name ? selected.name : '') }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)"
							>
							{{ $t('Remove') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import ModalAddPromo from '@/components/ModalAddPromo.vue';
import PromoForm from '@/components/PromoForm.vue';
import ModalPromoCodeList from '@/components/ModalPromoCodeList.vue';
import Pagination from '@/components/Pagination.vue';
import {
	getAxiosErrorMessage,
	delay,
	elpisisString,
	dateFormat,
}
	from '@/lib/helper';
import promosApi from '@/api/promos';
import packagesApi from '@/api/packages';

export default {
	name: 'Promo',
	components: {
		Modal,
		PromoForm,
		Pagination,
		ModalPromoCodeList,
		ModalAddPromo,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'created_at',
			sortBy: 'desc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isModalFeatureVisible: false,
			isRemoving: false,
			isFetching: false,
			hover: false,
			hoverItem: null,
			isFetchingPackage: false,
			packages: [],
			// modal list promo code
			isModalPromoCodeListVisible: false,
			isNewPromo: false,
			promoId: null,
			isModalAddPromoVisible: false,
		};
	},
	methods: {
		dateFormat(date) {
			return dateFormat(date, 'DD. MM. YYYY');
		},
		fetchPackage() {
			this.isFetchingPackage = true;
			const callback = (response) => {
				const items = response.data;
				this.packages = items;
				this.isFetchingPackage = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
				this.isFetchingPackage = false;
			};
			const paramsPackage = {
				page: 1,
				limit: 1000,
				order_by: 'id',
				sort_by: 'asc',
				// is_published: 1,
			};
			packagesApi.getList(paramsPackage, callback, errorCallback);
		},
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) this.isAll = true;
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Promos',
					text: message,
				});
				this.isFetching = false;
			};
			promosApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
				this.isNewPromo = true;
				this.promoId = item.id;
				this.showModalPromoCodeList(item);
			} else {
				this.$set(this.items, index, item);
				this.isNewPromo = false;
			}
		},
		resetNewPromo() {
			this.isNewPromo = false;
		},
		showModalPromoCodeList(item) {
			this.selected = item;
			this.isModalPromoCodeListVisible = true;
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Promos',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Promos',
					text: message,
				});
			};
			promosApi.delete(item.id, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		showModalPackageFeatures(item) {
			this.selected = item;
			this.isModalFeatureVisible = true;
		},
		showModalName(str) {
			return elpisisString(str);
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		showModalAddPromo(item) {
			this.selected = item;
			this.isModalAddPromoVisible = true;
		},
		numberingList(index) {
			if (this.page >= 1) {
				return index + 1 + (this.page * 10 - 10);
			}
			return index + 1;
		},
	},
	computed: {
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') params.keyword = keyword;
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	created() {
		this.fetch();
		this.fetchPackage();
	},
};
</script>
